<template>
    <div class="catch-details-container">
        <div class="loader-container" v-if="!catchDetails.id">
            <div class="loader"></div>
        </div>
        <div class="catch-details-card" v-if="catchDetails.id">
            <div class="header">
                <figure v-if="catchDetails.catcher.image">
                    <img
                        :src="catchDetails.catcher.image.small"
                        :title="catchDetails.catcher.image.title"
                    />
                </figure>
                <p>
                    <router-link
                        :to="{ name: 'Catchers', params: { id: catchDetails.catcher.id } }"
                    >{{ catchDetails.catcher.name }}</router-link>
                </p>
            </div>
            <div v-if="catchDetails.images[0]" class="picture">
                <figure>
                    <img :src="catchDetails.images[0].large" :title="catchDetails.images[0].title" />
                </figure>
            </div>
            <div class="description">
                <h1>{{ catchDetails.species.name }}</h1>
                <p>
                    <label>Dato:</label>
                    {{ parseDate(catchDetails.date) }}
                </p>
                <p>
                    <label>Vekt:</label>
                    {{ catchDetails.weight }}
                </p>
                <p>
                    <label>Lengde:</label>
                    {{ catchDetails.length }}
                </p>
                <p>
                    <label>Sted:</label>
                    <router-link
                        :to="{ name: 'RegionPage', params: { id: catchDetails.region.id } }"
                    >{{ catchDetails.region.name }}</router-link>
                </p>
                <p>
                    <label>Beskrivelse:</label>
                    {{ catchDetails.description }}
                </p>
            </div>
            <div class="button-container" v-if="isMyCatcher(catchDetails.catcher.id)">
                <div>
                    <router-link
                        :to="{
                            name: 'EditCatch',
                            params: { id: catchDetails.id },
                        }"
                    >Oppdater&nbsp;fangst</router-link>
                </div>
                <div class="divider"></div>
                <div>
                    <a v-on:click="showDeleteDialog = true">Slett&nbsp;fangst</a>
                    <DialogDisplay
                        :show="showDeleteDialog"
                        question="Vil du virkelig slette denne fangsten?"
                        :yes="() => deleteCatch(catchDetails.id)"
                        :no="() => showDeleteDialog = false"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import DialogDisplay from './../common/DialogDisplay.vue';
import api from '../../common/api';
import url from '../../common/url';
import { Bus, Stops } from '../../common/bus';


export default {
    props: ['id'],
    components: { DialogDisplay },
    computed: {
        ...mapGetters('session', ['isMyCatcher']),
    },
    data() {
        return {
            busyLoading: false,
            showDeleteDialog: false,
            catchDetails: {},
        };
    },
    async created() {
        Bus.$emit(Stops.NAVBAR, 'None');
        this.busyLoading = true;
        const details = await api.get(url.getCatch(this.id));
        this.busyLoading = false;
        if (details.error) return;
        this.catchDetails = details;
    },
    updated() {
        this.busyLoading = false;
    },
    methods: {
        ...mapMutations('catches', ['clearCache']),
        parseDate: dateToParse => new Date(dateToParse).toISOString().slice(0, 10),
        async deleteCatch() {
            this.busyLoading = true;
            const result = await api.delete(url.getCatch(this.catchDetails.id));
            this.busyLoading = false;
            if (result.error) {
                this.toggleDeleteDialog();
            } else {
                this.clearCache();
                this.$router.push({ name: 'Catches' });
                Bus.$emit(Stops.TOAST, 'Fangst slettet');
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$borderColor: rgb(230, 230, 230);
$bgColor: rgb(250, 250, 250);
$dividerColor: rgb(160, 160, 160);

.catch-details-container {
    display: flex;
    justify-content: center;

    .catch-details-card {
        background: white;
        margin: 1em;
        display: flex;
        flex-direction: column;
        border: 1px solid $borderColor;
        border-radius: 5px;
        max-width: $maxContentWidth;
        width: 100%;
        min-width: 240px;
        .header {
            display: flex;
            align-items: center;
            margin: 0.5em;
            height: 2.2rem;
            color: black;
            p {
                font-size: 1.2rem;
            }
            figure {
                width: 3.8em;
                img {
                    margin: 0.3rem 1rem 0rem 0.3rem;
                    max-width: 2.6rem;
                    max-height: 2.6rem;
                    border-radius: 1.3rem;
                }
            }
        }
        .picture img {
            width: 100%;
        }
        .description {
            margin: 0.8rem;
            font-size: 0.9rem;
            label {
                padding-right: 0.5rem;
                width: 500px;
                font-weight: bold;
            }
            h1 {
                font-size: 2rem;
                color: black;
                font-weight: 400;
                padding: 1rem 0 0.8rem 0;
            }
            p {
                line-height: 1.2rem;
            }
        }
    }
    .button-container {
        padding: 1rem;
        display: flex;
        justify-content: flex-end;
        font-size: 1.1rem;
        line-height: 2.3em;
        a {
            color: black;
            text-decoration: none;
            cursor: pointer;
        }
        .divider {
            margin: 0 1rem 0 1rem;
            border-right: 1px solid $dividerColor;
        }
    }
    .dialog-container {
        display: flex;
        position: absolute;
        justify-content: center;
        align-items: center;
        height: 80vh;
        .dialog {
            background-color: $bgColor;
            color: black;
            border: 1px solid $borderColor;
            padding: 2rem;
            margin: 1rem;
            border-radius: 5px;
        }
    }

    @mixin keyframes($name) {
        @-webkit-keyframes #{$name} {
            @content;
        }
        @-moz-keyframes #{$name} {
            @content;
        }
        @-ms-keyframes #{$name} {
            @content;
        }
        @keyframes #{$name} {
            @content;
        }
    }

    .loader-container {
        display: flex;
        height: 80vh;
        flex: 1;
        justify-content: center;
        align-items: center;
        .loader {
            border: 1rem solid #fafafa;
            border-top: 1rem solid #f0f0f0;
            border-radius: 50%;
            width: 7rem;
            height: 7rem;
            animation: spin 1s linear infinite;
            @include keyframes(spin) {
                0% {
                    transform: rotate(0deg);
                }
                100% {
                    transform: rotate(360deg);
                }
            }
        }
    }
}
</style>
